// extracted by mini-css-extract-plugin
export var reversed = "sectionWrapper-module--reversed--efaf2";
export var section_wrapper = "sectionWrapper-module--section_wrapper--fe3ce";